import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from '../calendar/actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import events from '../../containers/Calendar/demoEvents';

const getPropertyViewings = async () =>
  await SuperFetch.post(apiUrls.getPropertyViewings)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
export function* propertyViewings() {
  let viewings = yield call(getPropertyViewings);
  //viewings = events;
  yield [
    put(actions.setPropertyViewingData(viewings))
  ];
}

const doConfirmPropertyViewing = async (payload) => {
  const postData = {
    data: {
      hash: payload.payload.bookingHash
    }
  };
  return await SuperFetch.post(apiUrls.confirmPropertyViewing, postData)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
export function* confirmPropertyViewing(payload) {
  yield call(doConfirmPropertyViewing, payload);
  yield [
    put(actions.getPropertyViewingData())
  ];
}

const doConfirmRescheduledPropertyViewing = async (payload) => {
  const postData = {
    data: {
      hash: payload.payload.bookingHash
    }
  };
  return await SuperFetch.post(apiUrls.confirmRescheduledPropertyViewing, postData)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
export function* confirmRescheduledPropertyViewing(payload) {
  yield call(doConfirmRescheduledPropertyViewing, payload);
  yield [
    put(actions.getPropertyViewingData())
  ];
}

const doLandlordReschedule = async (payload) => {
  return await SuperFetch.post(apiUrls.landlordRescheduleBooking, payload.payload)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
export function* landlordReschedule(payload) {
  yield call(doLandlordReschedule, payload);
  yield [
    put(actions.getPropertyViewingData())
  ];
}

const doLandlordCancel = async (payload) => {
  const postData = {
    data: {
      hash: payload.payload.bookingHash
    }
  };
  return await SuperFetch.post(apiUrls.landlordCancelBooking, postData)
    .then(res => res)
    .catch(error => ({ error: JSON.stringify(error) }));
}
export function* landlordCancel(payload) {
  yield call(doLandlordCancel, payload);
  yield [
    put(actions.getPropertyViewingData())
  ];
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_PROPERTY_VIEWING_DATA, propertyViewings),
    takeEvery(actions.CONFIRM_PROPERTY_VIEWING, confirmPropertyViewing),
    takeEvery(actions.CONFIRM_RESCHEDULED_PROPERTY_VIEWING, confirmRescheduledPropertyViewing),
    takeEvery(actions.DO_LANDLORD_RESCHEDULE, landlordReschedule),
    takeEvery(actions.DO_LANDLORD_CANCEL, landlordCancel),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/calendar/sagas.js